export function toThousands(num: number | string) {
  const result = [];
  let counter = 0;
  const nums = (num || 0).toString().split('');
  for (let i = nums.length - 1; i >= 0; i--) {
    counter++;
    result.unshift(nums[i]);
    if (!(counter % 3) && i != 0) {
      result.unshift(',');
    }
  }
  return result.join('');
}

export function contains(arr1: any[], arr2: any[]) {
  if (arr1?.includes('*')) return true;
  for (const item of arr2) {
    if (arr1.includes(item)) return true;
  }
  return false;
}
export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const ObjectKeys = <T extends object>(obj: T): (keyof T)[] => {
  return Object.keys(obj) as (keyof T)[];
};

export function copyFormatText(val: string) {
  const el = document.createElement('textarea');
  el.style.whiteSpace = 'pre-wrap';

  el.value = val;

  document.body.appendChild(el);

  el.select();

  document.execCommand('copy');

  document.body.removeChild(el);
}

/*
@param {string} url  静态资源url
@param {string} filename  静态资源文件名(可选)
@param {string} target
*/
export const downloadFile = (url: string, filename?: string) => {
  const downloadElement = document.createElement('a');
  downloadElement.style.display = 'none';
  downloadElement.href = url;
  downloadElement.rel = 'noopener noreferrer';
  if (filename) {
    downloadElement.download = filename;
  }
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
};
